import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Song } from '../models/song';
import { getApiUrl } from '../../main';

@Injectable({
  providedIn: 'root'
})
export class SongService {
  private apiUrl = getApiUrl() + '/songs';

  constructor(private http: HttpClient) {}

  getSongs(): Observable<Song[]> {
    return this.http.get<Song[]>(this.apiUrl);
  }

  updateSong(id: number, song: Song): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, song);
  }

  deleteSong(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  createSong(song: Song): Observable<Song> {
    return this.http.post<Song>(this.apiUrl, song);
  }
}